module.exports = __webpack_public_path__ + "static/media/KatnissEverdeen.a76ca153.jpg";